/**
 * External dependencies
 */
import React from "react";
import classnames from "classnames";
import { size } from "lodash";
import { Box } from "@towersystems/towersystems-design-system";

/**
 * Internal dependencies
 */
import Main from "components/main";
import Button from "components/button";
import Icon from "components/icon";
import DropdownLink from "components/dropdown-link";

/**
 * Style dependencies
 */
import "./styles.scss";

const PageHeader = ({ goBackTitle = "Go back", ...props }) => {
  const renderPopoverTitle = () => {
    return (
      <DropdownLink
        labelStyle={{ fontSize: 25, fontWeight: "normal" }}
        label={props.title}
        items={props.headerPopoverItems}
      />
    );
  };

  const renderStringTitle = () => {
    return (
      <Box
        alignItems="center"
        justifyContent="spaceBetween"
        display="flex"
        className="page-header__title"
      >
        {props.title}
      </Box>
    );
  };

  const classes = classnames("page-header", {
    "has-drop-down": !!props.headerPopoverItems,
  });

  return (
    <Box className={classes}>
      <Main>
        <Box position="relative">
          {props.goBack && (
            <Button
              className="page-header__go-back"
              onClick={props.goBack}
              text
            >
              <Box display="flex" alignItems="center">
                <Icon marginRight={10} name="BsChevronLeft" />
                {goBackTitle}
              </Box>
            </Button>
          )}
          {size(props.headerPopoverItems) >= 2
            ? renderPopoverTitle()
            : renderStringTitle()}
          {props.subtitle && <Box>{props.subtitle}</Box>}
        </Box>
        {props.actions}
      </Main>
    </Box>
  );
};

export default PageHeader;
